import { UserInterface } from '@interfaces/auth';
export enum DiscountCodesType {
  All = 'allCodes',
  GiftCard = 'giftCard',
  PromoCode = 'promoCode',
  AffiliateCode = 'affiliateCode',
}

export enum DiscountCodesStatus {
  Draft = 'draft',
  Active = 'active',
  Inactive = 'inactive',
  Archived = 'archived',
  Scheduled = 'scheduled',
}

export enum DiscountType {
  GiftCard = 'giftCard',
  PromoCode = 'promoCode',
  AffiliateCode = 'affiliateCode',
}

export enum DiscountTypeLabes {
  giftCard = 'Gift Card',
  promoCode = 'Promo Code',
  affiliateCode = 'Partner Code',
}

export enum AmountType {
  Fixed = 'fixed',
  Percentage = 'percentage',
}

export enum CodeValidity {
  ExpiryDate = 'expiryDate',
  TimePeriod = 'timePeriod',
  Unlimited = 'unlimited',
}

export interface IInitialFilterValues {
  search: string;
  currentDiscountCodes: DiscountCodesType;
  orderKey: string;
  orderDirection: string;
}

export interface IPagination {
  perPage: number;
  currentPage: number | undefined;
  totalEntries: number | undefined;
}

export interface UsersAssociatedInterface {
  id: number | string;
  name: string;
}
export interface DiscountCodeInterface {
  id: number;
  code: string;
  type: string;
  description: string;
  amount: number;
  amountType: string;
  currency: string;
  amountUsed: number;
  minOrderPrice: number | undefined;
  useLimit: number | undefined;
  useTimes: number;
  status: string;
  startDate: Date | undefined;
  endDate: Date;
  associatedUser: UserInterface | undefined;
  associatedUserId: number | null;
  createdBy: string;
  createdByUser: UserInterface | undefined;
  createdAt: Date;
  comments: DiscountCodeCommentDto[];
  orders: any[];
  users: UserInterface[] | undefined;
}

export interface DiscountCodeCommentDto {
  id: number;
  discountCodeId: number;
  userId: number;
  body: string;
  createdAt: string;
  updatedAt: string;
  user: UserInterface;
}

export interface DiscountOrderDto {
  discountCodeId: number;
  orderId: number;
  userId: number;
  amount: number;
  discountCode: DiscountCodeInterface;
}

export interface UserDiscountCodeInterface {
  id: number;
  code: string;
  type: string;
  amount: number;
  amountType: string;
  currency: string;
  amountAvailable: number | undefined;
  orderNumber?: number;
  orders?: number[];
}
